import React, { useContext } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";

export default function BetItemDetailsToggle(props: {
	toggleDetails: () => void;
	isDetailsDisplayed?: boolean;
}) {
	const bet = useContext(MyBetsBetContext);

	if (!bet.betStatus) {
		return null;
	}

	const displayDetailsIndicatorClass = classNames("u-icon u-icon--xtny", {
		"u-icon--caret--up": props.isDetailsDisplayed,
		"u-icon--caret--right": !props.isDetailsDisplayed,
	});

	const { t } = useTranslation("mybets");

	const buttonText = !props.isDetailsDisplayed
		? t("REPORTS.SHOW_DETAILS")
		: t("REPORTS.HIDE_DETAILS");

	return (
		<button
			type="button"
			onClick={props.toggleDetails}
			className="table--bets__toggle btn btn--sml btn--ghost btn--icon no-print"
		>
			{buttonText}
			<i className={displayDetailsIndicatorClass} />
		</button>
	);
}
